import http from './request'

export interface LoginData {
  token: string
  user_id: string
  user_name: string
}

export function getCaptcha(params: { phone: string; device_id?: string }) {
  return http.get<unknown>('/login/captcha', { params })
}

export function login(params: { phone: string; captcha: string }) {
  return http.post<LoginData>('/login/smsloginsaveT', params)
}

export function setLoginInfo(token: string, userId: string, userName: string) {
  localStorage.setItem('token', token)
  localStorage.setItem('user_id', userId)
  localStorage.setItem('user_name', userName)
  localStorage.setItem('loginSuccessInfo', JSON.stringify({ token, userId, userName }))
}

export function isLoggedIn() {
  return !!localStorage.getItem('token')
}
